import React from 'react';

export default () => (
  <footer className='container-fluid black_more'>
  <div className='bg-footer'>
    <img src='./img/footer-img.png' alt='bg-footer'/>
  </div>
    <div className='row m-2-hor'>
      <div className='col-md-4'>
        <div className='footer-col'>
          <div className='heading'>
            <h2>About Us</h2>
          </div>
          <div className='content'>
             <p>We launch advertising on pornhub channel, and you will start earning on the views and subscribers that will come to your channel as a result of our advertising.</p>
          </div>
          <div className='link-call' onClick={()=> window.open("mailto:btom07459@gmail.com", "_self")}>btom07459@gmail.com</div>
        </div>
      </div>
      <div className='col-md-2'>
        <div className='footer-col'>
          <div className='heading'>
            {/*Usefull link*/}
          </div>
          <div className='content'>
             {/*<div className='link'>Frequently Asked</div>*/}
             {/*<div className='link'>Terms & Conditions</div>*/}
             {/*<div className='link'>Help Center</div>*/}
             {/*<div className='link'>Contact Us</div>*/}
          </div>
        </div>
      </div>
      <div className='col-md-2'>
        <div className='footer-col'>
          <div className='heading'>
            {/*Features*/}
          </div>
          <div className='content'>
            {/*<div className='link'>Career</div>*/}
            {/*<div className='link'>Brand Identity</div>*/}
            {/*<div className='link'>Investment</div>*/}
            {/*<div className='link'>Agency Patner</div>*/}
          </div>
        </div>
      </div>
      <div className='col-md-4'>
        <div className='footer-col'>
          <div className='heading'>
            Making money together
          </div>
          <div className='content'>
            <div className='info info_header'>
              <br/><span><a href="https://t.me/tomasbrown">Telegram: @tomasbrown</a></span>
              <br/><span><a href="mailto:btom07459@gmail.com">Mail: btom07459@gmail.com</a></span>
              <br/><span>Adress: Sankt Paulsgatan, 118 48 Stockholm, Sweden</span>
            </div>
            {/*<div className='socialicon'>*/}
            {/*<span className="shine"></span>*/}
            {/*  <i className="fa fa-facebook-f"></i>*/}
            {/*</div>*/}
            {/*<div className='socialicon'>*/}
            {/*<span className="shine"></span>*/}
            {/*  <i className="fa fa-linkedin"></i>*/}
            {/*</div>*/}
            {/*<div className='socialicon'>*/}
            {/*<span className="shine"></span>*/}
            {/*  <i className="fa fa-twitter"></i>*/}
            {/*</div>*/}
            {/*<div className='socialicon'>*/}
            {/*<span className="shine"></span>*/}
            {/*  <i className="fa  fa-instagram"></i>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </div>
    <div className='subfooter'>
      <div className='row m-2-hor'>
        <div className='col-md-6'>
          <div className='content'>© Copyrights 2021 M-Promotion All rights reserved.</div>
        </div>
      </div>
    </div>
  </footer>
);
